// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import NumberOfRecordsFound from '../../../../shared/components/number-of-records-found/index';
import PipHistory from '@deere/cps-it.warranty-model-factory/lib/pip-history';
import ReportGrid from '../../../shared/components/report-grid';
import ReportHeader from '../../../shared/components/report-header';
import ReportHiddenColumns from '../../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../../shared/components/show-no-results-found/show-no-results-found';
import WarrantyAgGridDatePicker from '../../../shared/components/ag-grid-date-picker';
import {getAgGridLocaleText} from '../../../../shared/utils/ag-grid-locale-text';
import {getColumnDefinitions} from '../../report-services/column-definitions';
import {getDefaultReportLayout} from '../../../shared/services/report-variant';

function handleOnGridReady(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

const ReportResults = props => {

    const gridOptions = {
        dateComponentFramework: WarrantyAgGridDatePicker
    };

    return (
     props.report.length > 0 ?
         <div>
             <NumberOfRecordsFound count={props.report.length}/>
             <section className='report'>
                 {props.isReportColumnsVisible && <ReportHiddenColumns/>}
                 <ReportHeader
                     columnApi={props.columnApi}
                     gridApi={props.gridApi}
                     reportName='pip-history'
                 />
                 <ReportGrid
                     columnDefs={getColumnDefinitions()}
                     gridOptions={gridOptions}
                     localeText={getAgGridLocaleText()}
                     onColumnVisible={props::onColumnRemoved}
                     onGridReady={props::handleOnGridReady}
                     rowData={props.report}
                 />
             </section>
         </div> :
         <ShowNoResultsFound showNoResultsFound={props.showNoResultsFound}/>
    );

};

ReportResults.displayName = 'ReportResults';
ReportResults.propTypes = {
    actions: PropTypes.object.isRequired,
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(PipHistory)).isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired
};

export default ReportResults;



// WEBPACK FOOTER //
// ./src/reports/pip-history/components/report-results/report-results.js